/* eslint-disable */

export function init() {
  const toggles = Array.from(document.querySelectorAll('.toggle'));

  ['load','resize'].map(event => window.addEventListener(event, () => {
      toggles.map(el => {
        // debugger;
        return el.style.setProperty('--max-height', `${(el.scrollHeight*2) + parseInt(el.getAttribute('data-padding'))}px`)
      });
  }));
}



// WEBPACK FOOTER //
// ./scripts/util/toggle.js